import React from "react";

export default function CityLocalContext({ cityName, localContext, commonProjects }) {
  return (
    <div className="bg-white p-6 rounded border border-gray-200">
      <div className="br-eyebrow text-br-bronze">Construction in {cityName}</div>
      <h2 className="br-headline text-2xl mt-2">Local Context & Project Types</h2>
      <p className="mt-3 text-gray-700 leading-relaxed">{localContext}</p>
      <h3 className="font-display tracking-widest uppercase mt-6 mb-2 text-sm">Common Black Ridge Projects in {cityName}</h3>
      <ul className="grid sm:grid-cols-2 gap-2 text-sm text-gray-700">
        {commonProjects.map((p) => (
          <li key={p} className="flex gap-2"><span className="text-br-bronze">▪</span> {p}</li>
        ))}
      </ul>
    </div>
  );
}
